document.addEventListener("DOMContentLoaded", function() {
  // Selecione o link do produto com base no atributo 'aria-label'
  const productLink = document.querySelector('a[aria-label="Johnny Shark Limoncello 20cl - Licor de Limão Português"]');

  if (productLink) {
    // Altere o href para o novo link desejado
    productLink.href = "https://johnny-shark.com/pages/johnny-shark-limoncello-20cl";
  }
});


document.addEventListener("DOMContentLoaded", function() {
  // Selecione o link do produto com base no atributo 'aria-label'
  const productLink = document.querySelector('a[aria-label="Johnny Shark Limoncello 70cl - Licor de Limão Português"]');

  if (productLink) {
    // Altere o href para o novo link desejado
    productLink.href = "https://johnny-shark.com/pages/compra-limoncello-johnny-shark";
  }

 const textBlock = document.querySelector('.footer-block.footer-block--text');
const logoBlock = document.querySelector('.footer-block.footer-block--logo');

// Criar a imagem
const img = document.createElement('img');
img.src = 'https://cdn.shopify.com/s/files/1/0783/3482/0658/files/logo_soueu.svg?v=1756129686';
img.alt = 'Logo SouEu';

// Aplicar o estilo

img.style.height = '38px';
img.style.marginRight = '50px';

// Inserir a imagem entre os elementos
if(textBlock && logoBlock) {
    textBlock.parentNode.insertBefore(img, logoBlock);
}

});
